module.exports = __webpack_public_path__ + "static/ma-2-sq-ae9bff75cb2dfa04c941a5bec1dd5f12.png";